import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import { Observable } from "rxjs/Observable";
import {
  SendMoneyDetail,
  SendMoneySteps
} from "../../models/sendmoney/sendmoney";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { CountryService } from "../../sharedcomponents/commonservice/countrylist.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import { InfoPopupComponent } from "../../sharedcomponents/_directive/info-popup/info-popup.component";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { StatelistComponent } from "../../sharedcomponents/_common/countrylist/statelist.component";
import { CitylistComponent } from "../../sharedcomponents/_common/countrylist/citylist.component";
import { Ng2DeviceService } from "ng2-device-detector";
import * as _ from "lodash";
@Component({
  selector: "app-branch",
  templateUrl: "./_branch-details.component.html",
  styleUrls: ["./_branch-details.component.css"],
  providers: [AlertService, Modal, CountryService]
})
export class BranchDetailsComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  countrycollection: any;
  stateCollection: any;
  cityCollection: any;
  BranchDetails: any;
  countryName: string;
  agentImgData: string;
  public filterByCollection = [];
  public sortByCollection = [];
  branchData: any = {};
  constructor(
    private router: Router,
    private modal: Modal,
    private alertService: AlertService,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    public utilitySer: utilityService,
    private vcRef: ViewContainerRef,
    private deviceService: Ng2DeviceService,
    public translate: TranslateService
  ) {
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.utilitySer.busy = this.sendMoneyService
      .getSendMoneyDetailData()
      .subscribe(data => {
        this.sendMoneyDetail = data;
      });
    this.PageFlow.Value = sessionStorage.PageFlow;
    if (
      this.sendMoneyDetail.pickupTypeDetails.countryName == undefined ||
      this.sendMoneyDetail.pickupTypeDetails.countryName == ""
    ) {
      if (this.PageFlow.Value == "repeatorder") {
        if (
          sessionStorage.RepeatOrderFlow != undefined &&
          sessionStorage.RepeatOrderFlow != ""
        ) {
          this.router.navigate(["/" + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(["/repeatorderlist"]);
        }
      } else {
        this.router.navigate(["/dashboard"]);
      }
      return;
    }
    this.BranchDetails = this.sendMoneyDetail.branches;
    this.populateFilterByandSortBy();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.PageFlow.Value != "repeatorder") {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        modalData.Title = this.translate.instant("Common_lblConfirm");
        modalData.Message = this.translate.instant(
          "SendMoney_navigateConfirmDesc"
        );
        this.modal
          .open(
            InfoPopupComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
          )
          .then(function(obj) {
            obj.onDestroy.subscribe(data => {
              console.log("Observer got a next value: " + data);
              if (modalData.next == "yes") {
                let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PickupCenter",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
                observer.next(true);
                observer.complete();
              } else {
                observer.next(false);
                observer.complete();
              }
            });
          });
      });
    }
    return true;
  }

  ngOnInit() {}
  InitPage() {
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    this.populateState();
    // this.branchData.StateTo = this.stateCollection[0].StateCode;

    this.branchData = this.sendMoneyDetail.agentDetails;
    this.branchData.StateTo = this.sendMoneyDetail.agentDetails.StateTo;
    // this.ddlStateOnChange(this.branchData.StateTo);
    const _self = this;
    this.cityCollection = this.stateCollection.filter(function(state) {
      return state.StateCode === _self.branchData.StateTo;
    })[0].Cities;
    this.branchData.CityTo = this.sendMoneyDetail.agentDetails.CityTo;
    this.searchForBranch();
  }
  populateFilterByandSortBy() {
    this.utilitySer.busy = this.sendMoneyService
      .getFilterBySortByData()
      .subscribe(
        data => {
          data.FilterBy = _.sortBy(data.FilterBy, "FilterByID");
          data.SortBy = _.sortBy(data.SortBy, "SortByID");
          this.filterByCollection = data.FilterBy;
          this.sortByCollection = data.SortBy;
          this.branchData.SortBy = data.SortBy[0].SortByID;
          this.branchData.FilterBy = data.FilterBy[0].FilterByID;
          this.InitPage();
        },
        error => {
          console.log("Observer got a next value: " + error);
        }
      );
  }

  populateState() {
    const countryCode = this.sendMoneyDetail.pickupTypeDetails
      .countryPreference;
    const coll = this.countrycollection.filter(function(country) {
      return country.CountryCode === countryCode;
    });
    this.branchData.CountryTo = coll[0].CountryCode;
    this.stateCollection = coll[0].states;
    this.countryName = coll[0].CountryNames[0].Name;
    // .filter(function(lang) {
    //   return (
    //     lang.Language.toUpperCase() === sessionStorage.langCode.toUpperCase()
    //   );
    // })[0].Name;
  }

  openStateBox() {
    let self = this;
    let modalData: any = {};
    modalData.CountryCode = this.branchData.CountryTo;
    return this.modal
      .open(
        StatelistComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function(obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next.StateCode == undefined) {
          } else {
            self.branchData.StateTo = modalData.next.StateCode;
            self.branchData.State = modalData.next.StateName;
            self.ddlStateOnChange(modalData.next.StateCode);
            self.openCityBox();
          }
        });
      });
  }

  openCityBox() {
    let self = this;
    let modalData: any = {};
    modalData.CountryCode = this.branchData.CountryTo;
    modalData.StateCode = this.branchData.StateTo;
    return this.modal
      .open(
        CitylistComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function(obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next.City == undefined) {
          } else {
            self.branchData.CityTo = modalData.next.City;
            // self.searchForBranch();
          }
        });
      });
  }

  ddlStateOnChange(stateCode) {
    if (stateCode == "") {
      this.cityCollection = [];
      return;
    }
    this.cityCollection = this.stateCollection.filter(function(state) {
      return state.StateCode === stateCode;
    })[0].Cities;
    if (this.cityCollection != null) {
      this.branchData.CityTo = this.cityCollection[0];
    }
  }

  // ddlStateOnChange(stateCode) {
  //   this.cityCollection = this.stateCollection.filter(function(state) {
  //     return state.StateCode === stateCode;
  //   })[0].Cities;
  //   if (this.cityCollection != null) {
  //     this.branchData.CityTo = this.cityCollection[0];
  //   }
  // }

  searchForBranch() {
    // this.sendMoneyDetail.agentDetails.CountryTo = this.branchData.CountryTo;
    // this.sendMoneyDetail.agentDetails.StateTo = this.branchData.StateTo;
    // this.sendMoneyDetail.agentDetails.CityTo = this.branchData.CityTo;
    // this.sendMoneyDetail.agentDetails.SortBy = this.branchData.SortBy;
    // this.sendMoneyDetail.agentDetails.FilterBy = this.branchData.FilterBy;
    let agentdata: any = JSON.parse(
      JSON.stringify(this.sendMoneyDetail.agentDetails)
    );
    if (
      this.sendMoneyDetail.pickupCenterDetails.LocationType.LocationTypeId === 2
    ) {
      agentdata.LocationId = 0;
    }

    agentdata.LocationId = 0;
    console.log("Es el 4");
    this.utilitySer.busy = this.sendMoneyService
      .getBranchDetails(agentdata)
      .subscribe(
        data => {
          if (data.StatusCode == 10000) {
            this.BranchDetails = data.Branches;
          } else {
            this.alertService.error(data.StatusMessage);
          }
        },
        error => {
          console.log("Observer got a next value: " + error);
        }
      );
  }

  continueClick() {
    if (this.PageFlow.Value == "repeatorder") {
      if (
        sessionStorage.RepeatOrderFlow != undefined &&
        sessionStorage.RepeatOrderFlow != ""
      ) {
        this.router.navigate(["/" + sessionStorage.RepeatOrderFlow]);
      } else {
        this.router.navigate(["/repeatorderlist"]);
      }
      return;
    } else {
      this.sendMoneyService.setModalPopup(SendMoneySteps.Beneficiary);
      this.router.navigate(["/sendmoney"]);
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_branch-details/_branch-details.component.ts